var _style, _polygon, _polygon2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMerrychefColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 842.6 72",
    style: {
      enableBackground: "new 0 0 842.6 72"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#C8202F;}\n\t.st1{clip-path:url(#SVGID_00000081642759271382967400000011620525316873449375_);fill:#C8202F;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "81.2,1.1 47.3,42.6 13.7,1.6 13.4,1.1 0,1.1 0,72 14,72 14,23.4 47.3,64.2 80.5,23.4 80.5,72 94.5,72  94.5,1.1 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "108.3,1.1 108.3,72 191.3,72 191.3,59.7 122.4,59.7 122.4,42.7 179.8,42.7 179.8,30.4 122.4,30.4  122.4,13.4 191.3,13.4 191.3,1.1 "
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0,
    y: 0,
    width: 842.6,
    height: 72
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000065788425006632877000000005089170877329871290_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000065788425006632877000000005089170877329871290_)",
      fill: "#C8202F"
    },
    d: "M378.9,72h-16l-16-19.5 h-38.3V72h-14V1.1h58.7c13.1,0,24.3,9.5,24.3,20.8v9.8c0,8.4-6,15.9-15.1,19.2L378.9,72z M308.5,40.2h44.7c5.7,0,10.2-3.8,10.2-8.5 v-9.8c0-4.7-4.6-8.5-10.2-8.5h-44.7V40.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000065788425006632877000000005089170877329871290_)",
      fill: "#C8202F"
    },
    d: "M286,72h-16l-16.1-19.5 h-38.3V72h-14V1.1h58.7c13.2,0,24.3,9.5,24.3,20.8v9.8c0,8.4-6,15.9-15.1,19.2L286,72z M215.7,40.2h44.7c5.7,0,10.2-3.8,10.2-8.5 v-9.8c0-4.7-4.6-8.5-10.2-8.5h-44.7V40.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000065788425006632877000000005089170877329871290_)",
      fill: "#C8202F"
    },
    points: "425.9,72  411.9,72 411.9,49.7 376.1,1.1 391.8,1.1 418.9,36.7 446,1.1 461.7,1.1 425.9,49.7  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000065788425006632877000000005089170877329871290_)",
      fill: "#C8202F"
    },
    d: "M520,72h-34.5 c-13.4,0-24.2-9.3-24.2-20.8V21.9c0-11.3,10.7-20.5,24.2-20.8H520c13,0,23.9,9.3,24.2,20.8l0,1.3h-14.1v-1.3 c0-4.7-4.6-8.5-10.2-8.5h-34.5c-5.6,0-10.2,3.8-10.2,8.5v29.3c0,4.7,4.6,8.5,10.2,8.5H520c5.6,0,10.2-3.8,10.2-8.5v-1.3h14v1.3 C544.3,62.5,533.2,72,520,72"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000065788425006632877000000005089170877329871290_)",
      fill: "#C8202F"
    },
    points: "636.8,72  622.8,72 622.8,42.7 567.8,42.7 567.8,72 553.8,72 553.8,1.1 567.8,1.1 567.8,30.4 622.8,30.4 622.8,1.1 636.8,1.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000065788425006632877000000005089170877329871290_)",
      fill: "#C8202F"
    },
    points: "732.6,72  649.6,72 649.6,1.1 732.6,1.1 732.6,13.4 663.6,13.4 663.6,30.4 721.1,30.4 721.1,42.7 663.6,42.7 663.6,59.7 732.6,59.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000065788425006632877000000005089170877329871290_)",
      fill: "#C8202F"
    },
    points: "756.2,72  742.1,72 742.1,1.1 825.2,1.1 825.2,13.4 756.2,13.4 756.2,30.4 813.6,30.4 813.6,42.7 756.2,42.7  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000065788425006632877000000005089170877329871290_)",
      fill: "#C8202F"
    },
    d: "M830.4,6.3 c0-1.1,0.3-2.1,0.8-3.1c0.5-1,1.3-1.8,2.2-2.3c1-0.6,2-0.8,3.1-0.8c1.1,0,2.1,0.3,3.1,0.8c0.9,0.5,1.7,1.3,2.2,2.3 c0.5,1,0.8,2,0.8,3.1c0,1.1-0.3,2.1-0.8,3.1c-0.5,1-1.3,1.7-2.2,2.3c-1,0.6-2,0.9-3.1,0.9c-1.1,0-2.2-0.3-3.1-0.9 c-0.9-0.6-1.7-1.3-2.2-2.3C830.6,8.4,830.4,7.4,830.4,6.3 M831.2,6.3c0,1,0.2,1.9,0.7,2.7c0.5,0.8,1.1,1.5,1.9,2 c0.8,0.5,1.7,0.7,2.6,0.7s1.8-0.2,2.6-0.7c0.8-0.5,1.4-1.2,1.9-2c0.5-0.8,0.7-1.7,0.7-2.7c0-1-0.2-1.8-0.7-2.7 c-0.5-0.8-1.1-1.5-1.9-2c-0.8-0.5-1.7-0.7-2.7-0.7c-1,0-1.8,0.2-2.6,0.7c-0.8,0.5-1.4,1.2-1.9,2C831.5,4.4,831.2,5.3,831.2,6.3  M839,4.8c0,0.4-0.1,0.8-0.4,1.2c-0.2,0.3-0.6,0.6-1,0.8l1.9,3.3h-1.4L836.5,7h-1.1V10h-1.2V2.6h2.1c0.9,0,1.6,0.2,2,0.5 C838.8,3.5,839,4,839,4.8 M835.4,6h0.9c0.4,0,0.8-0.1,1.1-0.3c0.3-0.2,0.4-0.5,0.4-0.9c0-0.4-0.1-0.7-0.3-0.9 c-0.2-0.2-0.6-0.3-1.1-0.3h-0.9V6z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerrychefColor);
export default __webpack_public_path__ + "static/media/Merrychef_Color.10ce69ce54ae858fd7fac8f2b4d388f5.svg";
export { ForwardRef as ReactComponent };